import Model from 'src/app/common/model';

export default class BroodBreederModel extends Model {
    id: string;
    name: string;
    code: string;
    description: string;
    species_type_id: number;
    createdby: string;
    updatedby: string;
    createdAt: Date;
    updatedAt: Date;

    constructor() {
        super();
    }
}
